import { render } from "./WizardFeedback.vue?vue&type=template&id=05c97b6a&ts=true"
import script from "./WizardFeedback.vue?vue&type=script&lang=ts"
export * from "./WizardFeedback.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__